import React from 'react';

import { useStandaloneFlags } from '../../../controllers/flags';
import { Flags } from './main';

const FlagsContainer = (): React.JSX.Element => {
	const [flags, actions] = useStandaloneFlags();

	return <Flags flags={flags} removeFlag={actions.removeFlag} />;
};

export default FlagsContainer;
